import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchMedia = async (searchKey) => {
  return await axios.get(
    API_URL +
      `/api/News/GetMediaGallery${
        !isEmpty(searchKey) ? "?searchString=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchMediaGalleryById = async ({ id }) => {
  return await axios.get(API_URL + `/api/News/GetMediaGalleryById/${id}`, {
    headers: securityHeaders,
  });
};

const deleteMediaImage = (id) => {
  return axios.post(
    API_URL + `/api/News/DeleteMediaGalleryImage/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteMediaImage = (id) => {
  return useMutation(() => deleteMediaImage(id));
};

const deleteMediaGallery = (id) => {
  return axios.post(
    API_URL + `/api/News/DeleteMediaGallery/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteMediaGallery = (id) => {
  return useMutation(() => deleteMediaGallery(id));
};

export const useFetchMedia = (searchKey) => {
  return useQuery({
    queryKey: ["media"],
    queryFn: () => fetchMedia(searchKey),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useFetchMediaGalleryById = ({ id }) => {
  return useQuery({
    queryKey: [`mediaGallery-${id}`],
    queryFn: () => fetchMediaGalleryById({ id }),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};
